module.exports = __webpack_public_path__ + "img/finance-bounty.b53f7fa8.svg";